// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GooglePlusOutlinedSvg from "@ant-design/icons-svg/es/asn/GooglePlusOutlined";
import AntdIcon from '../components/AntdIcon';

var GooglePlusOutlined = function GooglePlusOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: GooglePlusOutlinedSvg
  }));
};

GooglePlusOutlined.displayName = 'GooglePlusOutlined';
export default React.forwardRef(GooglePlusOutlined);